import appConstants from "../../../../../appConstants";
import { StaticFilter, MultiSelectFilter } from '@dataGrid/components/columnFilters';
import Tooltip from "../../../../common/StyledToolTip";
import DoneIcon from "@material-ui/icons/Done";
import CircularProgress from '@material-ui/core/CircularProgress';

export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }

    static booleanOptions = [
        { text: 'True', value: true},
        { text: 'False', value: false}
    ]

    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static CommandCellRenderer(props){
      const iconStyle={cursor:"pointer"};
      const commandMessgae = props.getValue();
      if(commandMessgae){
        return (
          <div >
            <CircularProgress size={16} color="primary"></CircularProgress>
            <span style={{paddingLeft:"4px"}}>{ commandMessgae }</span>
          </div>
        )
      }

      return (<div style={{
        display:"flex",
        justifyContent:"space-between",
        padding:"8px 16px 0 0"
      }}
        onClickCapture={(event) => {
          event.stopPropagation();
          props.api.runCommand?.(event.target.getAttribute("data-command"), props);
        }}
      >
        <Tooltip title="Edit Notification"><i style={iconStyle} className="icon-icon_edit" data-command={"edit"}/></Tooltip>
        <Tooltip title="Delete Notification"><i style={iconStyle} className="icon-icon_delete" data-command={"delete"}/></Tooltip>
      </div>)
    }

    static CheckRenderer(props){
        return props.value ? <DoneIcon style={{ margin: "8px 16px"}}/> :""
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.TerminalAcces,
      keyColumn: "notificationId",
      rowSelection: "single",
      defaultColDef:{
        filter: MultiSelectFilter
      },
      columnTypes: {
        "noSearchFilter": {
          getQuickFilterText:() => ""
        },
      },
      columns: [
        {
            headerName: "Id",
            headerTooltip: "Notification Id",
            field: "notificationId",
            minWidth: 0,
            hide:true
          },
        {
          headerName: "Type",
          headerTooltip: "Notification Type",
          field: "type",
          minWidth: appConstants.columnWidth.NOTIFICATION_TYPE,
          maxWidth: appConstants.columnWidth.NOTIFICATION_TYPE,
        },
        {
          headerName: "Message",
          headerTooltip: "Notification Message",
          field: "message",
          minWidth: appConstants.columnWidth.NOTIFICATION_MESSAGE,
        },
        {
          headerName: "Link",
          headerTooltip: "Link",
          field: "linkLabel",
          minWidth: appConstants.columnWidth.NOTIFICATION_LINK,
          maxWidth: appConstants.columnWidth.NOTIFICATION_LINK + 100,
        },
        {
          headerName: "Closable",
          headerTooltip: "Closable",
          field: "isClosable",
          cellRenderer: GridConfig.CheckRenderer,
          minWidth: appConstants.columnWidth.NOTIFICATION_ISCLOSABLE,
          maxWidth: appConstants.columnWidth.NOTIFICATION_ISCLOSABLE,
          filter: StaticFilter,
          type:"noSearchFilter",
          filterParams:{
            staticOptions: GridConfig.booleanOptions
          },
        },
        {
          headerName: "Commands",
          headerTooltip: "Commands",
          field: "command",
          cellRenderer: GridConfig.CommandCellRenderer,
          minWidth: appConstants.columnWidth.NOTIFICATION_COMMAND,
          maxWidth: appConstants.columnWidth.NOTIFICATION_COMMAND,
          type:"noSearchFilter",
          filter: null
        },
      ]
    }
  }
}

